



































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import BaseContainer from '@/components/BaseContainer.vue';
import StatusPanel from '@/components/StatusPanel.vue';
import BaseInfoPanel from '@/components/BaseInfoPanel.vue';
import { Inquiry, yun } from '@/http';
import ButtonPanel from '@/components/ButtonPanel.vue';
import orderDetailcc from './orderDetailcc.vue';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { formRules } from '@/common/util/validator';
import { upload } from '../../common/util/ossUploadService';

import ImagesUploadorder from '@/components/ImagesUploadorder.vue';
import { enums } from '@/common/enums';

import { default as DataPanel } from '@/components/DataPanel.vue';
import publicFunc from '../../common/util/publicFunc';
@Component({
    components: {
        BaseContainer,
        StatusPanel,
        BaseInfoPanel,
        ButtonPanel,
        ImagesUploadorder,
        orderDetailcc,
        PageDescribe,
        DataPanel,
    },
})
export default class InquiryDetail extends Vue {
    public winVisible = false;
    public formDataWin: any = {};
    public loading: boolean = false;
    public adjustCarrierVisible = false;
    public requoteVisible = false;
    public title: string = '订单状态为待接单，支持用户在线编辑订单，支持重新、终结、删除订单';
    public cspdiaConfig: any = {
        cspDialogVisible: false,
        title: '询价单终结',
        content: '确认终结询价单？',
    };
    public publicFunc: any = publicFunc;
    public formRules = formRules;
    public id: any = '';
    public name: any = '';
    public detailData: any = {};
    public goodsList: any = [];
    public goodsUnitType = enums.goodsUnitTypeNum;
    public freightUnitType = enums.freightUnitType;
    public pricingModeType = enums.pricingModeType;

    public formData: any = {
        carrierId: '',
        carrierName: '',
        priceSource: '',
        pricingMode: '',
        freightPrice: '',
        freightUnit: '',
        goodsList: [
            {
                orderId: '',
                goodsName: '',
                quantity: '',
                unit: '',
                planQuantity: '',
                planGoodsUnit: '',
                model: '',
                remark: '',
                id: '',
            },
        ],
        originProvince: '',
        originCity: '',
        originCounty: '',
        arrivalProvince: '',
        arrivalCity: '',
        arrivalCounty: '',
        totalPlanQuantity: '',
        totalPlanQuantityUnit: 1,
        splitCarrierOrderCount: '',
    };
    public detials: any = '';
    public async created() {
        this.id = this.$route.query.id;
        this.name = this.$route.query.name;
        this.getdd();
    }
    public sssingin(data, index) {
        this.sssing = index;
        this.formData.freightPrice = data.priceValue;
        if (this.formData.pricingMode == 1) {
            this.formData.freightUnit = 1;
        } else {
            this.formData.freightUnit = 2;
        }
    }
    handleInput2(e, index) {
        e.target.value = e.target.value.match(/\d{1,9}(\.\d{0,4})?/) ? e.target.value.match(/\d{1,9}(\.\d{0,4})?/)[0] : '';
        this.formData.freightPrice = e.target.value;
    }
    handleInput4(e, index) {
        e.target.value = e.target.value.match(/\d{1,9}(\.\d{0,4})?/) ? e.target.value.match(/\d{1,9}(\.\d{0,4})?/)[0] : '';
        this.formData.totalPlanQuantity = e.target.value;
    }
    public cars: any = [];
    public carLengthList: any = [];
    public vehicleTypeList: any = [];
    public sssing: any = '';
    public async getdd() {
        this.carLengthList = await yun.GetDicList({ typeName: 'carLength' });
        this.vehicleTypeList = await yun.GetDicList({ typeName: 'vehicleType' });
        let dd = await yun.OrdergetDetaill(this.id);
        let skip = 1;
        dd.goodsList.map((data) => {
            data.index = skip;
            skip = skip + 1;
            data.planQuantity = data.quantity;
            data.planGoodsUnit = data.unit;
        });
        this.detials = dd;
        this.formData.totalPlanQuantity = dd.planWeight;
        this.formData.originProvince = this.detials.originProvince;
        this.formData.originCity = this.detials.originCity;
        this.formData.originCounty = this.detials.originCounty;
        this.formData.arrivalProvince = this.detials.arrivalProvince;
        this.formData.arrivalCity = this.detials.arrivalCity;
        this.formData.arrivalCounty = this.detials.arrivalCounty;
        this.sssing = '';
        let resd = await yun.GetFreight({
            carLength: this.detials.carLength,
            inquiryCode: this.detials.inquiryCode,
        });
        console.log(resd);
        this.formData.carriageWay = resd.carriageWay ? resd.carriageWay : this.formData.carriageWay;
        if (resd.carrierId) {
            this.carrierId1 = resd.carrierId;
            this.carrierName1 = resd.carrierName;
        }

        this.CarriageWay1 = resd.carriageWay;
        this.cars = [];
        if (resd.cars) {
            this.cars = resd.cars;
            this.formData.priceSource = 1;
            this.formData.pricingMode = 1;
            this.formData.carrierId = this.carrierId1;
            this.formData.carrierName = this.carrierName1;
            if (resd.cars.length == 1) {
                this.sscar(0, resd.cars[0]);
            }
        }
    }
    selectCar1(data) {
        this.formData.carrierId = data.id;
        this.GetPrice();
    }
    public SinglePriceList: any = [];
    async GetPrice() {
        this.SinglePriceList = [];
        if (!this.formData.carrierId) {
            return;
        }
        if (!this.formData.pricingMode) {
            return;
        }
        let data = {
            carrierId: this.formData.carrierId,
            priceListType: this.formData.pricingMode,
            deliveryProvince: this.detials.originProvinceStr,
            deliveryCity: this.detials.originCityStr,
            deliveryArea: this.detials.originCountyStr,
            arrivalProvince: this.detials.arrivalProvinceStr,
            arrivalCity: this.detials.arrivalCityStr,
            arrivalArea: this.detials.arrivalCountyStr,
            titleName: this.detials.carLength,
            weight: this.formData.totalPlanQuantity,
        };
        let res = await yun.getSinglePriceList(data);
        this.SinglePriceList = res.priceListDetails[0].priceContent;
        // this.formData.freightUnitPrice = res.extData;
        console.log('this.SinglePriceList', this.SinglePriceList, res);
    }
    public carrierId1: any = '';
    public carrierName1: any = '';
    public CarriageWay1: any = '';

    public ischange: any = false;

    public freightSourceChange() {
        this.formData.carrierId = '';
        this.formData.carrierName = '';
        this.formData.freightUnit = '';
        this.formData.freightPrice = '';
        this.formData.pricingMode = '';
        this.sssing = '';
        this.sscar = '';
        this.carrierChange();
        if (this.formData.priceSource == 1) {
            this.formData.carrierId = this.carrierId1;
            this.formData.carrierName = this.carrierName1;
            this.formData.pricingMode = 1;
        }
    }
    viewInquiry(data) {
        if (this.detials.goodsList.length == 1) {
            this.$alert('至少保留一条货物数据');
            return;
        }
        this.detials.goodsList.splice(data.index - 1, 1);
        let skip = 0;
        this.detials.goodsList.map((item, index) => {
            item.index = skip++ + 1;
        });
    }
    carrierNameEnd() {
        if (this.formData.carrierId) {
        } else {
            this.formData.carrierName = '';
        }
    }
    carrierNamechange() {
        this.formData.carrierId = '';
    }
    public carCodechange(val) {
        this.formData.carrierId = '';
    }
    public carCodeEnd() {
        console.log('cc2');
        if (!this.formData.carrierId) {
            this.formData.carrierName = '';
            this.formData.freightUnit = '';
            this.formData.freightPrice = '';
        }
    }
    public carrierChange1(data) {
        if (this.formData.pricingMode == 2 || this.formData.pricingMode == 3) {
            this.sscar = '';
            this.sssing = '';
            this.formData.freightUnit = '';
            this.formData.freightPrice = '';
            this.GetPrice();
        }
    }
    public carrierChange() {
        this.sscar = '';
        this.sssing = '';
        this.formData.freightUnit = '';
        this.formData.freightPrice = '';
        this.GetPrice();
    }
    async querySearch1(queryString, cb) {
        let res = await yun.GetCarrierList({ Name: this.formData.carrierName, count: -1 });
        console.log(res.data);
        let result = [];
        res.data.forEach((dd) => {
            let xx = {
                value: dd.name,
                id: dd.id,
            };
            result.push(xx);
        });
        cb(result);
    }
    public sscar: any = '';
    carss(index, resd) {
        this.sscar = index;
        this.formData.freightPrice = resd.price ? resd.price : this.formData.price;
        this.formData.freightUnit = 1;
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            //给每一行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }
    back() {
        this.$router.back();
    }
    public tableData: any = [];
    public shipperAttachmentList: any = [];
    public dialogConfig: any = {
        title: '终结该运单',
        show: false,
    };
    confirmClose() {
        this.dialogConfig = {
            title: '',
            show: false,
        };
    }

    async confirmOk() {
        this.dialogConfig = {
            show: false,
        };
        if (this.btt == 4) {
            this.formData.goodsList.forEach((item) => {
                if (item.planQuantity) {
                    try {
                        let nn = (item.planQuantity + '').split('.')[1];
                        if (nn.length > 4) {
                            item.planQuantity = Number((item.planQuantity + '').split('.')[0] + '.' + nn.slice(0, 4));
                        }
                    } catch (e) {}
                }
            });
            let res = await yun.splitadd(this.formData);
            this.$message.success('分单发运成功!');
            this.$router.push('/orderManager');
        }
    }
    public btt: any = 0;
    public ssid: any = '';

    ordergo() {
        let istabe = true;
        this.formData.goodsList = [];
        this.detials.goodsList.forEach((item) => {
            if (!item.planQuantity || !item.planGoodsUnit) {
                istabe = false;
            } else {
                item.planQuantity = item.planQuantity + '';
                try {
                    console.log(item.planQuantity.split('.').length);
                    if (item.planQuantity.split('.').length > 2) {
                        item.planQuantity = item.planQuantity.split('.')[0];
                    }
                } catch (e) {
                    console.log(e);
                }

                item.planQuantity = Number(item.planQuantity);
            }
            let xx = {
                goodsId: item.id,
                orderId: this.detials.id,
                ...item,
            };
            this.formData.goodsList.push(xx);
        });
        if (!istabe) {
            this.$alert('请将货物信息填写完整');
            return;
        }
        console.log('formdata', this.formData);
        this.$refs.formData.validate(async (valid) => {
            if (valid) {
                this.ssid = '';
                this.btt = 4;
                this.dialogConfig = {
                    title: '分单发运',
                    show: true,
                };
                // this.$confirm('确认派车?', '确认派车', {
                //     confirmButtonText: '确定',
                //     cancelButtonText: '取消',
                //     type: 'warning',
                // })
                //     .then(async () => {
                //         this.formData.goodsList.forEach(item=> {
                //             if (item.planQuantity) {
                //                 try {
                //                     let nn = (item.planQuantity + '').split('.')[1]
                //                     if (nn.length > 4) {
                //                         item.planQuantity =Number((item.planQuantity + '').split('.')[0]+'.' + nn.slice(0, 4))
                //                     }
                //                 }catch (e) {
                //
                //                 }
                //             }
                //             if (!item.goodsName || !item.unit) {
                //                 istabe = true
                //             }
                //         })
                //             let res = await yun.CarrierOrder(this.formData)
                //             this.$message.success('派车成功!');
                //             this.$router.back()
                //         }
                //     )
            }
        });
    }
    public $refs: {
        formData: HTMLFormElement;
        formData1: HTMLFormElement;
        formData2: HTMLFormElement;
    };
    /**装车要素 */
    public activeName: any = 'first';
    setImage(name, url, uid) {
        console.log('url=====>' + url);
        this.shipperAttachmentList.push({
            name: name,
            url: url,
            id: '',
        });
        this.formData.carrierAttList = this.shipperAttachmentList;
        // console.log('add-attachementUrls======>', this.shipperAttachmentList);
    }
    deleteImage(name, uid, url) {
        this.shipperAttachmentList = this.shipperAttachmentList.filter((v) => {
            return v.url !== url;
        });
        // console.log('del-attachementUrls', this.shipperAttachmentList, this.shipperAttachmentList.length);
    }
    public title1 = '新增车辆';
    public formData1: any = {
        carCode: '',
        carLength: '',
        carLengthInt: '',
        carType: '',
        carTypeInt: '',
        totalMass: '',
        approvedLoad: '',
        enabled: true,
        drivingLicenseImg: '',
        roadTransportCertificateImg: '',
        businessLicenseImg: '',
    };
    drivingLicenseImgs: any = [];
    roadTransportCertificateImgs: any = [];
    businessLicenseImgs: any = [];
    public dialogVisible: any = false;
    public addNew() {
        this.title = '新增车辆';
        this.drivingLicenseImgs = [];
        this.roadTransportCertificateImgs = [];
        this.businessLicenseImgs = [];
        this.formData1 = {
            carCode: '',
            carLength: '',
            carLengthInt: '',
            carType: '',
            carTypeInt: '',
            totalMass: '',
            approvedLoad: '',
            enabled: true,
            drivingLicenseImg: '',
            roadTransportCertificateImg: '',
            businessLicenseImg: '',
        };
        this.dialogVisible = true;
        this.$refs.formData1.resetFields();
    }

    public save() {
        this.$refs.formData1.validate(async (valid) => {
            if (valid) {
                if (this.title == '新增车辆') {
                    let res = await yun.CarAdd(this.formData1);
                    this.$alert('添加成功');
                    this.dialogVisible = false;
                } else {
                    let res = await yun.CarUpdate(this.formData1);
                    this.$alert('编辑成功');
                    this.dialogVisible = false;
                }
            }
        });
    }
    public handleClose() {
        this.dialogVisible = false;
    }
    public dialogVisible1: any = false;
    public handleClose1() {
        this.dialogVisible1 = false;
    }
    handleClick() {}
    public carLengthChange(item) {
        //this.form.platformCompanyId = item.code
        this.carLengthList.forEach((data) => {
            if (data.value == item) this.formData1.carLength = data.name;
        });
    }
    public carTypeChange(item) {
        //this.form.platformCompanyId = item.code
        console.log('item', item);
        this.vehicleTypeList.forEach((data) => {
            if (data.value == item) this.formData1.carType = data.name;
        });
    }
    public urls: any = [];
    showViewer: any = false;
    public handlePreview(file) {
        this.urls = [];
        this.showViewer = true;
        this.urls = [file.url];
    }
    cc;
    store;
    async handleUpload1(param, data) {
        this.cc = data;
        console.log('123', param, data);
        let res = await upload(param.file, param.file.name);
        if (res.res.statusCode == '200') {
            var imageUrl = res.res.requestUrls[0].split('?')[0];
            this.$set(this.formData1, data + '', imageUrl);
            console.log('12344', this.formData1);
        } else {
            this.$alert(`上传失败，请重新上传`);
        }
    }
    handleRemove1(param, data) {
        console.log('datas', data, this.formData1);
        this.$set(this.formData1, data + '', '');
    }
    async handleUpload2(param, data) {
        this.cc = data;
        console.log('123', param, data);
        let res = await upload(param.file, param.file.name);
        if (res.res.statusCode == '200') {
            var imageUrl = res.res.requestUrls[0].split('?')[0];
            this.$set(this.formData2, data + '', imageUrl);
            console.log('12344', this.formData2);
        } else {
            this.$alert(`上传失败，请重新上传`);
        }
    }
    handleRemove2(param, data) {
        console.log('datas', data, this.formData2);
        this.$set(this.formData2, data + '', '');
    }
    public formData2: any = {
        id: '',
        phone: '',
        name: '',
        idCode: '',
        enabled: true,
        idImg: '',
        driverLicenseImg: '',
        qualificationCertificateImg: '',
    };
    public title2 = '新增司机';
    iDImgs: any = [];
    QualificationCertificateImgs: any = [];
    driverLicenseImgs: any = [];
    public addNew1() {
        this.title = '新增司机';
        this.iDImgs = [];
        this.driverLicenseImgs = [];
        this.QualificationCertificateImgs = [];
        this.formData2 = {
            phone: '',
            name: '',
            idCode: '',
            enabled: true,
            idImg: '',
            driverLicenseImg: '',
            qualificationCertificateImg: '',
        };
        this.dialogVisible1 = true;
        this.$refs.formData2.resetFields();
    }

    public save1() {
        this.$refs.formData2.validate(async (valid) => {
            if (valid) {
                if (this.title == '新增司机') {
                    let res = await yun.DriverAdd(this.formData2);
                    this.$alert('添加成功');
                    this.dialogVisible1 = false;
                    console.log(this.formData2);
                } else {
                    let res = await yun.DriverUpdate(this.formData2);
                    this.$alert('编辑成功');
                    this.dialogVisible = false;
                }
            }
        });
    }
    handleInput3(e, index) {
        e.target.value = e.target.value.match(/^([0]|[1-9][0-9]*)?/) ? e.target.value.match(/^([0]|[1-9][0-9]*)?/)[0] : '';
        this.formData.splitCarrierOrderCount = e.target.value;
    }
    handleInput(e, index) {
        e.target.value = e.target.value.match(/\d{1,9}(\.\d{0,4})?/) ? e.target.value.match(/\d{1,9}(\.\d{0,4})?/)[0] : '';
        this.formData.goodsList[index].planQuantity = e.target.value;
    }
    public paginationOptions = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public total = 0;
    public pageSizes = [50];
    public lastPageNum = 0;
    public pageSize: number = 50;
    public firstPageBtnDisabled = true;
    public lastPageBtnDisabled = false;
    public handleCurrentChange(val) {
        console.log('onPaginationChange', val);
        this.firstPageBtnDisabled = val === 1 ? true : false;
        this.lastPageBtnDisabled = val === Math.ceil(this.total / this.paginationOptions.count) ? true : false;
        this.paginationOptions.currentPage = val;
        this.paginationOptions.skip = (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
        console.log('this.paginationOptions~', this.paginationOptions);
    }
    public handleSizeChange(val) {
        console.log('handleSizeChangeval' + JSON.stringify(val));

        this.paginationOptions.count = val;
        this.paginationOptions.currentPage = 1;
        this.handleCurrentChange(this.paginationOptions.currentPage);
        if (Math.ceil(this.total / val) < this.paginationOptions.currentPage) {
            this.paginationOptions.skip = 0;
        } else {
            this.paginationOptions.skip = (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
        }
    }
}
